/**
 * Cuenta
 *
 * @author edmsamuel
 */
import Api from '../Api';
export const APP_ACCOUNT_SET = 'APP_ACCOUNT_SET';
export const APP_ACCOUNT_CLOSE = 'APP_ACCOUNT_CLOSE';
export const APP_ACCOUNT_ERROR = 'APP_ACCOUNT_ERROR';

/**
 * Cierra la sesión
 *
 */
export function appAccountClose() {
  return {
    type: APP_ACCOUNT_CLOSE
  };
}

/**
 * Carga la sesión desde al almacenamiento local
 *
 */
export function appAccountLoad(cb) {
  const token = Api.getUserId();
  if (token !== null && token) {
    return dispatch => {
      Api.get('/usuarios/me')
        .then(response => {
          if (!response.data.iIdProveedor) {
            return Promise.reject(new Error('Proveedor no asignado a usuario'))
          }

          Api.setUserData(response.data)
          return Api.query({
            __returnType: 'one',
            model: 'ComProveedor',
            where: { iId: response.data.iIdProveedor },
          })
        })
        .then(response => {
          dispatch(appAccountSet(response.data))
          cb && cb(response.data)
        })
        .catch((err) => {
          alert(err.message)
          dispatch({ type: APP_ACCOUNT_CLOSE })
        });
    };
  } else {
    return appAccountClose();
  }
}

/**
 * Establece una nueva cuenta
 *
 * @param {Object} account
 */
export function appAccountSet(account) {
  return {
    type: APP_ACCOUNT_SET,
    data: account
  }
}
